import { render, staticRenderFns } from "./workspace-breadcrumb.vue?vue&type=template&id=3a779616&scoped=true"
import script from "./workspace-breadcrumb.vue?vue&type=script&lang=js"
export * from "./workspace-breadcrumb.vue?vue&type=script&lang=js"
import style0 from "./workspace-breadcrumb.vue?vue&type=style&index=0&id=3a779616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a779616",
  null
  
)

export default component.exports